import React, { PureComponent, Fragment } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Spinner } from 'formlabs-web-components/Navigation';
import { Input } from 'formlabs-web-components/Form';
import { Header } from 'formlabs-web-components/Type';
import { Button } from 'formlabs-web-components/Link';
import Cookies from 'js-cookie';
import { withTranslation, Trans } from 'react-i18next';

import CenterModal from '../modal/CenterModal';
import { analytics } from '../../utils';
import './NewsLetterSignUp.module.css';
import CountrySelect from './selects/CountrySelect';
import StateSelect from './selects/StateSelect';

import OccupationSelect from './selects/OccupationSelect';
import identifyIntegrations from './identifyIntegrations';

const PreformForm = DisplayComponent(
  class PreformDownload extends PureComponent {
    state = {
      submitting: false,
      submitted: false,
      error: false,
      country: null
    };

    onFormSubmit(e) {
      e.preventDefault();
      this.setState({ submitting: true, error: false });
      const csrftoken = Cookies.get('csrftoken');
      const { platform } = this.props;
      const form = e.target;
      let form_data = new FormData(form);

      analytics.identify(
        form_data.get('tfa_5'),
        {
          email: form_data.get('tfa_5'),
          firstName: form_data.get('tfa_2'),
          lastName: form_data.get('tfa_3'),
          phone: form_data.get('tfa_58')
        },
        identifyIntegrations
      );
      analytics.track(
        'PreForm Downloaded',
        {
          category: 'Segment',
          email: form_data.get('tfa_5')
        },
        {
          integrations: {
            Marketo: false,
            'Marketo V2': false
          }
        }
      );
      fetch(form.action, {
        method: 'POST',
        body: form_data,
        headers: {
          'X-CSRFToken': csrftoken
        }
      })
        .then(res => res.json())
        .then(response => {
          this.setState({
            submitted: true,
            submitting: false,
            open: true,
            error: false
          });
          const url = `/download-preform-${platform.toLowerCase()}`;
          if (window) {
            window.location.href = url;
          }
        })
        .catch(error => {
          this.setState({
            submitted: false,
            submitting: false,
            error: true
          });
        });
    }

    onCountrySelect = e => {
      this.setState({ country: e.target.value });
    };

    render() {
      const { submitting, submitted, error, country } = this.state;
      const { platform, t } = this.props;
      const isUs = country === 'United States';
      return (
        <Fragment>
          {!submitted && (
            <form
              action="/form_proxy/"
              className="contact-sales-form ga-track"
              styleName="contact-form"
              data-ga-action="Submit sales inquiry"
              id="tfa_0"
              method="POST"
              onSubmit={this.onFormSubmit.bind(this)}
            >
              <Grid direction="x" gutters="margin">
                <Cell mediumSize={24}>
                  <Header level={4} displayAs={4} weight="400">
                    {t('Download PreForm')}
                  </Header>
                  <p>
                    <strong>
                      {t(
                        'Fill out the form below to begin downloading PreForm'
                      )}
                    </strong>
                  </p>
                </Cell>
              </Grid>
              <Grid direction="x" gutters="margin">
                <Cell mediumSize={12}>
                  <label id="tfa_2-L" class="label preField " for="tfa_2">
                    {t('First Name')}
                  </label>
                  <Input
                    type="text"
                    id="tfa_2"
                    name="tfa_2"
                    value=""
                    title="First Name"
                    required
                    data-dataset-allow-free-responses=""
                  />
                </Cell>

                <Cell mediumSize={12}>
                  <label id="tfa_3-L" class="label preField " for="tfa_3">
                    {t('Last Name')}
                  </label>
                  <Input
                    type="text"
                    id="tfa_3"
                    name="tfa_3"
                    value=""
                    title="Last Name"
                    required
                    data-dataset-allow-free-responses=""
                  />
                </Cell>
              </Grid>
              <label id="tfa_5-L" class="label preField " for="tfa_5">
                {t('Business Email')}
              </label>
              <Input
                type="email"
                id="tfa_5"
                name="tfa_5"
                value=""
                title="Business Email"
                required
                data-dataset-allow-free-responses=""
              />
              <label id="tfa_58-L" class="label preField " for="tfa_58">
                {t('Phone')}
              </label>
              <Input
                type="text"
                id="tfa_58"
                name="tfa_58"
                value=""
                title="Phone"
                required
                data-dataset-allow-free-responses=""
              />
              <Grid direction="x" gutters="margin">
                <Cell mediumSize={24}>
                  <label id="tfa_30-L" class="label preField " for="tfa_30">
                    {t('How Would You Describe Yourself')}
                  </label>
                  <OccupationSelect
                    id="tfa_30"
                    name="tfa_30"
                    required
                    title="How would you describe yourself?"
                  />
                </Cell>
                <Cell mediumSize={isUs ? 12 : 24}>
                  <label id="tfa_39-L" class="label preField " for="tfa_39">
                    {t('Country')}
                  </label>
                  <CountrySelect
                    id="tfa_39"
                    name="tfa_39"
                    required
                    withFavorites
                    onChange={this.onCountrySelect}
                  />
                </Cell>

                {isUs && (
                  <Cell mediumSize={12}>
                    <label class="label preField " for="state">
                      {t('State')}
                    </label>
                    <StateSelect name="tfa_57" id="state" required />
                  </Cell>
                )}
              </Grid>
              <Input
                type="hidden"
                id="tfa_42"
                name="tfa_42"
                value=""
                title="Referral URL"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_37"
                name="tfa_37"
                value=""
                title="Language Preference"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_41"
                name="tfa_41"
                value=""
                title="_tfa_mkt_trk"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_43"
                name="tfa_43"
                value=""
                title="Acquisition Source - First"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_44"
                name="tfa_44"
                value=""
                title="Acquisition Source - Last"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_45"
                name="tfa_45"
                value=""
                title="gclid"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_47"
                name="tfa_47"
                value=""
                title="utm_campaign - First"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_48"
                name="tfa_48"
                value=""
                title="utm_campaign - Latest"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_49"
                name="tfa_49"
                value=""
                title="utm_pt - First"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_50"
                name="tfa_50"
                value=""
                title="utm_pt - Latest"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_51"
                name="tfa_51"
                value=""
                title="utm_content - First"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_52"
                name="tfa_52"
                value=""
                title="utm_content - Latest"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_53"
                name="tfa_53"
                value=""
                title="utm_term - First"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_54"
                name="tfa_54"
                value=""
                title="utm_term - Latest"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_55"
                name="tfa_55"
                value=""
                title="utm_medium - First"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                id="tfa_56"
                name="tfa_56"
                value=""
                title="utm_medium - Latest"
                data-dataset-allow-free-responses=""
                class=""
              />
              <Input
                type="hidden"
                value="374162"
                name="tfa_dbFormId"
                id="tfa_dbFormId"
              />
              <Input
                type="hidden"
                value=""
                name="tfa_dbResponseId"
                id="tfa_dbResponseId"
              />
              <Input
                type="hidden"
                value="469c7661b8d8efc3b06da8e557b10a7a"
                name="tfa_dbControl"
                id="tfa_dbControl"
              />
              <Input
                type="hidden"
                value="16"
                name="tfa_dbVersionId"
                id="tfa_dbVersionId"
              />
              <Input
                type="hidden"
                value=""
                name="tfa_switchedoff"
                id="tfa_switchedoff"
              />

              <Grid direction="x" gutters="margin">
                <Cell mediumSize={8}>
                  {' '}
                  <br />
                  {!submitting && (
                    <input
                      className="button"
                      type="submit"
                      value={t('Download PreForm')}
                    />
                  )}
                  {submitting && (
                    <span styleName="submitting">
                      <Spinner size={3} color="#0762c8" />
                    </span>
                  )}
                </Cell>
                <Cell mediumSize={16} secondaryAlignment="align-self-middle">
                  {error && !submitted && (
                    <span>
                      <small>
                        {t(
                          'There was an error submitting your request. Please try again!'
                        )}
                      </small>
                    </span>
                  )}
                </Cell>
              </Grid>
            </form>
          )}
          {submitted && (
            <Fragment>
              <Header displayAs={2} level={2} weight={600}>
                {t('Thanks for Downloading PreForm')}
              </Header>
              <p>
                <Trans>
                  Your download should start soon. If it doesn't please click{' '}
                  <a href={`/download-preform-${platform.toLowerCase()}`}>
                    here
                  </a>
                </Trans>
              </p>
            </Fragment>
          )}
        </Fragment>
      );
    }
  }
);

const preventDefaultHandler = event => {
  event.preventDefault();
};

const PreformDownload = DisplayComponent(
  class PreformDownload extends PureComponent {
    quickbutton = React.createRef();

    state = {
      open: false
    };

    handleLinkClick = e => {
      this.quickbutton.current.addEventListener(
        'click',
        preventDefaultHandler,
        {
          passive: false
        }
      );
      this.setState({
        open: true
      });
    };
    handleClose = () => {
      this.quickbutton.current.removeEventListener(
        'click',
        preventDefaultHandler
      );
      this.setState({
        open: false
      });
    };

    render() {
      const { classes, t, platform, query, email } = this.props;
      const { open } = this.state;
      return (
        <Fragment>
          {query === 'update' || email ? (
            <Button
              className={classes}
              color={platform === 'Windows' ? 'dark' : 'light'}
              to={`/download-preform-${platform.toLowerCase()}`}
              target="_blank"
              ref={this.quickbutton}
            >
              {t('Download PreForm ({{platform}})', {
                platform: platform
              })}
            </Button>
          ) : (
            <Button
              className={classes}
              color={platform === 'Windows' ? 'dark' : 'light'}
              to="#"
              onClick={e => this.handleLinkClick(e)}
              ref={this.quickbutton}
            >
              {t('Download PreForm ({{platform}})', {
                platform: platform
              })}
            </Button>
          )}
          {open ? (
            <CenterModal
              id="preform-download"
              onClose={this.handleClose}
              width="600px"
            >
              <PreformForm platform={platform} t={t} />
            </CenterModal>
          ) : null}
        </Fragment>
      );
    }
  }
);

export default compose(
  connect(state => {
    return {
      email: state.auth.email
    };
  }),
  withTranslation()
)(PreformDownload);
